/* eslint-disable import/prefer-default-export */
import { ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetCountryList = () => {
  return Request.call({
    url: `/countryList?type=testItem&isTestPlanUse=true`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}/api/v2`,
  });
};
export const apiGetTestItemCitations = async (params = {}) => {
  return Request.call({
    url: '/micro/test-items/citations',
    method: 'GET',
    params: {
      ...params,
      pageNo: 1,
      pageSize: 10000,
    },
    apiPrefix: `${ApiV1Base}/api/v1`,
  });
};
